import React from 'react';
import PropTypes from 'prop-types';
import { Button, makeStyles, useMediaQuery } from '@material-ui/core';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { languageSelector } from '../../store/selectors/appSelectors';
import { primaryColorSelector } from '../../store/selectors/globalConfigSelectors';
import { useSelector } from 'react-redux';

const useButtonStyles = (back) =>
  makeStyles((theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      color: `${theme.palette.common.white}!important`,
    },
    disabled: {
      background: `${theme.palette.grey[500]}!important`,
    },
  }));

const ButtonNavigation = ({ next, back, disabled, children, onClick, type = 'button' }) => {
  const classes = useButtonStyles(back)();
  const { primaryColor } = useSelector((state) => ({
    primaryColor: primaryColorSelector(state),
  }));
  const themeStyles = {
    background: primaryColor,
  };

  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant={next ? 'contained' : 'contained'}
      color="primary"
      startIcon={back && <ArrowBackIosIcon />}
      endIcon={next && <ArrowForwardIosIcon />}
      size={isMobileView ? 'small' : 'large'}
      classes={{ root: classes.root, disabled: classes.disabled }}
      style={themeStyles}
      type={type}
    >
      {children}
    </Button>
  );
};

ButtonNavigation.propTypes = {
  next: PropTypes.bool,
  back: PropTypes.bool,
  disabled: PropTypes.bool,
};

ButtonNavigation.defaultProps = {
  disabled: false,
  back: false,
  next: false,
};

export default ButtonNavigation;
